import { ServiceModalConstant } from '../actions/constants/ServiceModalConstant';
import { ServiceModalAction } from '../actions/ServiceModalAction';
import { ServiceStatusAction } from '../actions/ServiceStatusAction';
import { isAdminPathname } from './isAdminPathname';

/**
 * WebSocket 수신 메시지 라우팅 (IMP-203: WebSocketService 에서 추출).
 * 주의: 완전한 순수 함수는 아니다 — SERVICE_MODAL_NEW_TICKET 분기에서 BUG-077 Admin 가드를 위해
 *       `window.location.pathname`(isAdminPathname) 과 `localStorage.user` 를 직접 참조한다.
 *       (동치 이동 결과로 의존 유지. 향후 pathname 을 인자로 받으면 테스트 격리가 더 쉬워진다.)
 * @param {string} rawData - WebSocket event.data (JSON 문자열)
 * @param {Function} dispatch - redux dispatch
 * @param {Object} [context] - { issueManagerIds: string[] } 호출부(onmessage)에서 Store 에서 추출해 주입
 */
export const routeWebSocketMessage = (rawData, dispatch, context = {}) => {
  try {
    const data = JSON.parse(rawData);
    console.log('[WS] Message received:', data.type || '');
    if (data.type === 'SERVICE_STATUS_UPDATE') {
      // BUG-163: WS payload 의 카운트는 수신자 read scope(HQ=전사 / 그 외 소속+하위)를 반영하지 못해
      //          목록·새로고침 배지(getStatus/getCounts)와 불일치한다(전사 179 vs enabled+IM 서브트리 1).
      //          payload 값을 직접 쓰지 않고 getCounts 재조회를 트리거해 카운트 소스를 단일화한다.
      //          (WS 는 "값이 바뀌었으니 재조회하라" 신호로만 사용 — BUG-039/040/054 재발 계열 근절)
      dispatch(ServiceStatusAction.GetCounts());
    }
    if (data.type === 'SERVICE_MODAL_ISSUE_ALERT' && data.payload) {
      // BUG-077: Admin 경로에서만 + 백엔드 검증 후 표시 (race condition 방지)
      // RefreshAndShowIfNew 내부에서 Admin 경로 재검증
      dispatch(ServiceModalAction.RefreshAndShowIfNew());
    }
    if (data.type === 'SERVICE_MODAL_NEW_TICKET' && data.payload) {
      // BUG-077: Admin 경로 체크 — RefreshAndShowIfNew 내부에서도 재검증
      if (!isAdminPathname(window.location.pathname)) return;
      // Issue Manager → 백엔드 검증 후 표시, 비 Issue Manager → NEW_TICKET 표시
      const { issueManagerIds = [] } = context;
      let isIssueManager = false;
      try {
        const user = JSON.parse(localStorage.getItem('user') || '{}');
        isIssueManager = issueManagerIds.includes(user.adminid);
      } catch (e) { /* fallback to NEW_TICKET */ }

      if (isIssueManager) {
        // Issue Manager → 백엔드에서 최신 상태 검증 후 표시
        dispatch(ServiceModalAction.RefreshAndShowIfNew());
      } else {
        dispatch({
          type: ServiceModalConstant.WS_NEW_TICKET,
          payload: data.payload,
        });
      }
    }
    if (data.type === 'SERVICE_MODAL_ALERT_RESOLVED' && data.payload) {
      dispatch({
        type: ServiceModalConstant.WS_ALERT_RESOLVED,
        payload: data.payload,
      });
    }
  } catch (err) {
    console.warn('[WS] Message parse error:', err);
  }
};
